const objectsEqual = (obj1, obj) => JSON.stringify(obj1) === JSON.stringify(obj);

export default objectsEqual;
